<template>
    <div>
        <!-- Alvo do Teleport para breadcrumb (oculto; evita erro ao navegar quando páginas usam teleport to="#breadcrumb") -->
        <div id="breadcrumb" class="vue-portal-target" style="position: absolute; left: -9999px; width: 1px; height: 1px; overflow: hidden;"></div>

        <!--  BEGIN NAVBAR  -->
        <Header v-if="!layoutState.isAuth"></Header>
        <!--  END NAVBAR  -->

        <!--  BEGIN MAIN CONTAINER  -->
        <div class="main-container" id="container" :class="containerClasses">
            <!--  BEGIN OVERLAY  -->
            <div
                v-if="!layoutState.isAuth && !isHorizontal"
                class="overlay"
                :class="{ show: !layoutState.showSidebar }"
                @click="toggleSidebar"
            ></div>
            <div v-if="!layoutState.isAuth" class="search-overlay" :class="{ show: layoutState.showSearch }" @click="toggleSearch"></div>
            <!-- END OVERLAY -->

            <!--  BEGIN SIDEBAR  -->
            <Sidebar v-if="!layoutState.isAuth && !isHorizontal"></Sidebar>
            <!--  END SIDEBAR  -->

            <!--  BEGIN CONTENT AREA  -->
            <div id="content" class="main-content" :class="layoutState.isAuth ? 'auth-layout' : ''">
                <router-view />
            </div>
            <!--  END CONTENT AREA  -->

            <!-- BEGIN APP SETTING LAUNCHER -->
            <app-settings v-if="!layoutState.isAuth && !isHorizontal" />
            <!-- END APP SETTING LAUNCHER -->

            <!-- BEGIN NOTIFICATION TOASTS -->
            <NotificationToast />
            <!-- END NOTIFICATION TOASTS -->
            
            <!-- BEGIN FLOATING MENU (Mobile) -->
            <FloatingMenu />
            <!-- END FLOATING MENU -->

            <LegalGraceBanner />
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { useLayout } from '@/composables/useLayout';
    import Header from "../components/layout/header.vue";
    import Sidebar from "../components/layout/sidebar.vue";
    import appSettings from "../components/app-settings.vue";
    import NotificationToast from "../components/notifications/NotificationToast.vue";
    import FloatingMenu from "../components/layout/FloatingMenu.vue";
    import LegalGraceBanner from "../components/legal/LegalGraceBanner.vue";

    const { layoutState, toggleSidebar, toggleSearch } = useLayout();

    const isHorizontal = computed(() => layoutState.value.menuStyle === 'horizontal');

    const containerClasses = computed(() => {
        if (isHorizontal.value) {
            // Menu horizontal: não adiciona classes de sidebar
            return [
                layoutState.value.isAuth ? 'main-container-auth' : ''
            ];
        }
        return [
            !layoutState.value.showSidebar ? 'sidebar-closed sbar-open' : '',
            layoutState.value.menuStyle === 'collapsible-vertical' ? 'collapsible-vertical-mobile' : '',
            layoutState.value.isAuth ? 'main-container-auth' : ''
        ];
    });

    
</script>
